import { render } from "./bmsProjectForm.vue?vue&type=template&id=3a3da188&scoped=true"
import script from "./bmsProjectForm.vue?vue&type=script&lang=js"
export * from "./bmsProjectForm.vue?vue&type=script&lang=js"

import "./bmsProjectForm.vue?vue&type=style&index=0&id=3a3da188&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3da188"]])

export default __exports__